import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AlNavigationService } from '@al/ng-navigation-components';

@Component({
    selector: 'portero-general-error',
    templateUrl: './general-error.component.html',
    styleUrls: [ './general-error.component.scss' ],
})

export class GeneralErrorComponent implements OnInit {

    public errorType:string =   "default";

    constructor( public navigation:AlNavigationService,
                 public route:ActivatedRoute ) {
    }

    ngOnInit() {
        this.errorType = this.route.snapshot.paramMap.get('errorType') || "default";
    }
}
